import moment from 'moment';

export default {
  // Number formatter
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  formatNiceDate(date) {
    if (!date) { return null; }
    let today = moment();
    date = moment(date);
    if (date.isSame(today, 'day')) {
      return 'today';
    } else {
      return date.format('M/D/YYYY');
    }
  },

  simplePluralization(count, token) {
    if (!token) { return null; }
    if (count === 1) {
      return token;
    } else {
      return token + 's';
    }
  }

};



// WEBPACK FOOTER //
// ./src/utils/formattingUtils.js